import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="tooltip"
export default class extends Controller {
	static values = {
		breite: Number,
	}

	connect() {
		this.tooltip = this.createTooltip()
		// Controller Actions zum Element hinzufügen
		const controllerActions = "mouseenter->tooltip#show mouseleave->tooltip#hide"
		if (this.element.dataset.action) {
			this.element.dataset.action = this.element.dataset.action.concat(" ", controllerActions)
		} else {
			this.element.dataset.action = controllerActions
		}
	}

	disconnect() {
		this.tooltip.remove()
	}

	show() {
		this.positionieren()
		enter(this.tooltip)
	}

	hide() {
		leave(this.tooltip)
	}

	// Private Methods

	createTooltip() {
		const span = document.createElement("span")

		span.innerHTML = this.element.getAttribute("tooltip")
		// Style
		span.classList.add(
			"absolute",
			"z-30",
			"bg-white",
			"px-3",
			"py-2",
			"text-xs",
			"rounded-lg",
			"ring-1",
			"ring-gray-900/10",
			"text-farbe-grau",
		)
		// Animation
		span.dataset.transitionEnter = "transform transition-all ease-out duration-200 delay-200 origin-bottom"
		span.dataset.transitionEnterStart = "opacity-0 scale-95 translate-y-1"
		span.dataset.transitionEnterEnd = "opacity-100 scale-100 translate-y-0"
		span.dataset.transitionLeave = "transform transition-all ease-in duration-100 origin-bottom"
		span.dataset.transitionLeaveStart = "opacity-100 scale-100 translate-y-0"
		span.dataset.transitionLeaveEnd = "opacity-0 scale-95 translate-y-1"

		// Rendern im DOM und Speichern der Breite für die Positionierung
		span.style.top = "-1000px"
		span.style.left = "-1000px"

		document.querySelector("body").appendChild(span)

		this.breiteValue = span.offsetWidth
		span.classList.add("hidden")

		return span
	}

	positionieren() {
		switch (this.element.getAttribute("tooltip_pos")) {
			case "bottom":
				this.tooltip.classList.add("mt-10")
				break
			default:
				this.tooltip.classList.add("-mt-10")
				break
		}

		const rect = this.element.getBoundingClientRect()

		// Berechne die Position des Tooltip-Elements damit dieser mittig ausgerichtet ist
		const tooltipX = rect.left + window.scrollX + rect.width / 2 - this.breiteValue / 2
		const tooltipY = rect.top + window.scrollY

		this.tooltip.style.left = `${tooltipX}px`
		this.tooltip.style.top = `${tooltipY}px`
	}

	openRow(event) {
		// Allow tooltip hover, but still open the row (overlay link) when clicked.
		// We forward the click to the invisible overlay link within the same row.
		const container = this.element.closest(".group")
		const link = container?.querySelector('a[data-row-link="true"]')
		if (link) link.click()
	}
}
